import { Outlet } from "react-router-dom";
import SideBar from "../components/views/SideBar";
import HeaderName from "../components/views/HeaderName";
import SideBarSetting from "../components/Settings/SideBarSetting";
import "./SettingLayout.css";

const SettingLayout = () => {
  return (
    <div>
      <SideBar />
      <HeaderName />
      <div className="outlet-container">
        <div className="setting-layout-container">
          <SideBarSetting />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingLayout;
